module.exports = __webpack_public_path__ + "img/instructions_button.6bac2b00.png";